import { useEffect } from "react";
import { API_BASE_URL } from "@shared/config";
import { useLocalization } from "@i18n";
import { Button } from "@telluscompany/design-system";
import { AppBackground } from "@shared/components";

export default function AuthRedirect() {
  const { translate } = useLocalization();
  const urlParams = new URLSearchParams(window.location.search);
  const urlError = urlParams.get("error");

  useEffect(() => {
    if (!urlError) {
      window.location.href = `${API_BASE_URL}/v1/auth/login?platform=web`;
    }
  }, [urlError]);

  if (urlError) {
    return (
      <AppBackground className="min-h-screen flex items-center justify-center font-sans p-4">
        <div className="surface-primary p-10 rounded-lg shadow-md text-center max-w-md w-full">
          <h1 className="text-2xl font-semibold mb-4">
            ❌ {translate("common.error")}
          </h1>

          <p className="mb-6 text-muted-foreground">
            <strong className="font-semibold text-foreground">
              {translate("common.error")}:
            </strong>{" "}
            {urlError}
          </p>

          <Button onClick={() => window.location.reload()}>
            {translate("auth.tryAgain")}
          </Button>
        </div>
      </AppBackground>
    );
  }

  return null;
}
